import React, { createContext, useContext, useState } from 'react';
import { Lang } from '../services/Services';
//import Spinner from '../components/Spinner';
import ProgressBar from '../components/ProgressBar';



export const LoadingContext = createContext();

export const useLoadingCtx = () => useContext(LoadingContext);

export const LoadingContextProvider = ({ children }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [isGameReady, setIsGameReady] = useState(false);
    const [isNetworkMessageVisible, setNetworkMessageVisible] = useState(false);
    const [completed, setCompleted] = useState(0);

    const closeNetworkMessage = (e) => {
        e.preventDefault();
        setNetworkMessageVisible(false);
    };

    return (
        <LoadingContext.Provider
            value={{
                setIsVisible,
                isGameReady,
                setIsGameReady,
                setNetworkMessageVisible,
                setCompleted
            }}
        >
            {children}
            {isVisible && (
                <div className='loading-overlay'>
                    <div className='content'>
                        <table >
                        <tbody>
                            <tr>
                            <td>
                                <ProgressBar bgcolor={"#6a1b9a"} completed={completed} />
                            </td>
                            </tr>
                            <tr>
                            <td>
                                <p>{Lang?.home?.loading || 'Loading Assets'}</p>
                            </td>
                            </tr>
                        </tbody>
                        </table>
                    </div>
                </div>
            )}
            {isNetworkMessageVisible && (
                <div className='network-modal'>
                <div className='content'>
                    <p>{Lang?.home?.loading_offline || 'You are offline'}</p>
                    <button className='btn' onClick={closeNetworkMessage}>{Lang?.home?.loading_offline_ok || 'Ok'}</button>
                </div>
            </div>
            )}
        </LoadingContext.Provider>
    )
};